import type { WorkItemDto } from '@customTypes/types';

import { ManageWorkInviteView } from './ManageWorkInviteView';
import { useManageWorkInviteView } from './useManageWorkInviteView';

export const ManageWorkInviteViewContainer = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const {
    functions: { rejectInvite, acceptInvite }
  } = useManageWorkInviteView({ workItem });
  return (
    <ManageWorkInviteView
      acceptInvite={acceptInvite}
      rejectInvite={rejectInvite}
    />
  );
};
